import ProductTransformer from './ProductTransformer';

export default class ProductDetailsTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteDetails') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    [
      'productName',
      'productDescriptionDetails',
      'providerName',
      'productRequirementsDetails',
      'productGroupUpperDescriptionDetails',
      'productGroupSelectionLabelDetails',
      'productGroupLowerDescriptionDetails',
      'priceInformation',
      'promotionPriceOverrideText',
      'regularPriceOverrideText',
      'minimumCommitmentPeriodOverrideText',
      'minimumCommitmentPeriodText',
      'beforeOptinInfoText',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
